<svg class="MediaControlsIconReset" width="24" height="29" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M21.333 16.24A9.333 9.333 0 0 0 12 6.908h-.785l1.728 1.728-1.886 1.886-4-4a1.333 1.333 0 0 1 0-1.886l4-4 1.886 1.886-1.72 1.72H12c6.627 0 12 5.372 12 12 0 6.627-5.373 12-12 12s-12-5.373-12-12c0-3.582 1.571-6.799 4.057-8.996l1.766 1.999a9.308 9.308 0 0 0-3.156 6.997 9.333 9.333 0 1 0 18.666 0z"
  />
</svg>
